import * as React from "react";

interface IErrorBoundaryProps {
    errorMessage:  string;
}

interface IErrorBoundaryState {
    errorInfo: React.ErrorInfo|null;
    error: Error|null;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
      super(props);
      this.state = { error: null, errorInfo: null };
    }
    
    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      this.setState({
        error,
        errorInfo
      })

      // TODO: Log errors to a reporting svc?

    }
    
    public render() {
      if (this.state.errorInfo) {
        // Error path
        return (
          <div>
            <h2>{this.props.errorMessage}</h2>
            <div style={{ whiteSpace: "pre-wrap" }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </div>
          </div>
        );
      }
      // Normally, just render children
      return this.props.children;
    }  
  }
 
  export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/core/ErrorBoundary/ErrorBoundary.tsx